// src/pages/Login.js
import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert
} from '@mui/material';
import { motion } from 'framer-motion';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTheme } from '../ThemeContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(location.state?.message || null);
  const { setMode } = useTheme();

  // Force light theme on login page
  useEffect(() => {
    setMode('light');
  }, [setMode]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    const { error: loginError } = await login({ email, password });

    if (loginError) {
      setError(loginError.message);
    } else {
      const from = location.state?.from?.pathname || "/";
      navigate(from === '/login' ? '/' : from, { replace: true });
    }
  };

  return (
    <Container maxWidth="sm" component={motion.div}>
      <Box sx={{ 
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%', borderRadius: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
            <Box sx={{ 
              bgcolor: 'primary.main',
              borderRadius: '50%',
              p: 1,
              mb: 2
            }}>
              <LockOutlinedIcon sx={{ color: 'white' }} />
            </Box>
            <Typography variant="h5" gutterBottom>
              Inloggen
            </Typography>
          </Box>

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess(null)}>
              {success}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleLogin} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="E-mail"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              inputProps={{
                autoComplete: 'username'
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Wachtwoord"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              inputProps={{
                autoComplete: 'current-password'
              }}
            />
            <Button
              variant="contained"
              type="submit"
              fullWidth
              sx={{ mt: 3, mb: 2, py: 1.2 }}
            >
              Inloggen
            </Button>
            <Button
              component={Link}
              to="/forgot-password"
              color="primary"
              fullWidth
              sx={{ mt: 1, textDecoration: 'none' }}
            >
              Wachtwoord vergeten?
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}